export enum PermissaoEnum {
  Master_Usuario_Listar = 1,
  Master_Usuario_Incluir = 2,
  Master_Usuario_Excluir = 3,
  Master_Usuario_Alterar = 4,

  Master_Perfil_Listar = 5,
  Master_Perfil_Incluir = 6,
  Master_Perfil_Excluir = 7,
  Master_Perfil_Alterar = 8,

  Desenvolvedor_Logs_Listar = 16,
  Desenvolvedor_Logs_VisualizarDadosSensiveis = 17,
  Desenvolvedor_CategoriaArquivo_Listar = 23,
  Desenvolvedor_CategoriaArquivo_Incluir = 24,
  Desenvolvedor_CategoriaArquivo_Excluir = 25,
  Desenvolvedor_CategoriaArquivo_Alterar = 26,

  Desenvolvedor_Arquivo_Listar = 27,
  Desenvolvedor_Arquivo_Incluir = 28,
  Desenvolvedor_Arquivo_Excluir = 29,

  Desenvolvedor_TabelaIbpt_Alterar = 41,
  Desenvolvedor_TabelaIbpt_Listar = 42,
  Desenvolvedor_TabelaIbpt_Incluir = 43,
  Desenvolvedor_TabelaIbpt_Excluir = 44,

  InteligenciaDados_ConfigurarRelatorio_Listar = 11,
  InteligenciaDados_ConfigurarRelatorio_Incluir = 12,
  InteligenciaDados_ConfigurarRelatorio_Excluir = 13,
  InteligenciaDados_ConfigurarRelatorio_Alterar = 14,

  InteligenciaDados_MeusRelatorios_Listar = 15,

  RepositorioTintas_Fabricante_Alterar = 18,
  RepositorioTintas_Fabricante_Listar = 19,

  Suporte_SuperAcesso_Listar = 20,
  Suporte_SuperAcesso_Incluir = 21,

  Implantacao_Empresa_Alterar = 30,
  Implantacao_Empresa_Listar = 31,
  Implantacao_Empresa_Incluir = 32,
  Implantacao_Empresa_Excluir = 33,

  Implantacao_GrupoEmpresa_Alterar = 34,
  Implantacao_GrupoEmpresa_Listar = 35,
  Implantacao_GrupoEmpresa_Incluir = 36,
  Implantacao_GrupoEmpresa_Excluir = 37,

  Suporte_Notificacao_Visualizar = 38,
  Suporte_Notificacao_Inserir = 39,
  Suporte_Notificacao_Excluir = 40,
}
